import { render } from "./InputNumberPhone.vue?vue&type=template&id=76204f52&scoped=true"
import script from "./InputNumberPhone.vue?vue&type=script&lang=js"
export * from "./InputNumberPhone.vue?vue&type=script&lang=js"

import "./InputNumberPhone.vue?vue&type=style&index=0&id=76204f52&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76204f52"]])

export default __exports__